import { render, staticRenderFns } from "./PageEventABCBooks.vue?vue&type=template&id=1e915fc3&scoped=true&"
import script from "./PageEventABCBooks.vue?vue&type=script&lang=js&"
export * from "./PageEventABCBooks.vue?vue&type=script&lang=js&"
import style0 from "./PageEventABCBooks.vue?vue&type=style&index=0&id=1e915fc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e915fc3",
  null
  
)

export default component.exports